import { Field } from 'redux-form';
import EmojiRatingInput from './EmojiRating';

const EmojiRating = (props) => {
  return (
    <div>
      <Field
        {...props}
        component={EmojiRatingInput}
      />
    </div>
  );
}

export default EmojiRating;